import styles from './styles.module.scss'
import Item1Icon from './icons/item_1-icon.png'
import Item2Icon from './icons/item_2-icon.png'
import Item3Icon from './icons/item_3-icon.png'
import Item4Icon from './icons/item_4-icon.png'
import { useTranslation } from 'utils/use-translation'

export default function Advantages() {
  const { t } = useTranslation()
  
  return (
    <div className={styles.items}>
      <div className={styles.item}>
        <img className={styles.item__icon} src={Item1Icon} alt="item icon" />
        <p className={styles.item__text}>{t('guaranteed')}<br /> {t('payouts')}
        </p>
      </div>

      <div className={styles.item}>
        <img className={styles.item__icon} src={Item2Icon} alt="item icon" />
        <p className={styles.item__text}>{t('unlimited_referrals')}<br />{t('referrals')}</p>
      </div>

      <div className={styles.item}>
        <img className={styles.item__icon} src={Item3Icon} alt="item icon" />
        <p className={styles.item__text}>
          {t('more_refer')}<br/>{t('more_btc')}
        </p>
      </div>

      <div className={styles.item}>
        <img className={styles.item__icon} src={Item4Icon} alt="item icon" />
        <p className={styles.item__text}>{t('daily_interest_on')}<br />{t('savings_rewards')}</p>
      </div>
    </div>
  )
}
